import {SuperOmega} from '@didi/superomega'
import OmegaTracker from '@didi/omega-tracker';
import { getCookie } from '../utils/commonFunc';
import Env from  '@/env/env';
import { SET_EXPLORER_NAME ,SET_WORKBENCH_VERSION} from '@/common/js/const';
let cookies = {}
const cookieMap = {}
const getCommonParam = function () {
	cookies = document.cookie || ""
	cookies.split('; ').map(item => {
	  const t = item.split('=')
	  cookieMap[t[0]] = t[1]
    return true
	})
}

export default SuperOmega
export const setLocation = SuperOmega.setLocation
export const setCountryAndCity = SuperOmega.setCountryAndCity


const set_workbench_type =() =>{
  let { href } = window.location
  let workbench_type = 'offline' // 异步
  if(href.includes('fe/im')){
    workbench_type = 'livechat' // im
  } else if(href.includes('ark/genesys')){
    workbench_type = 'phone' // 电话
  } 
  return workbench_type
}

const omegaEvnetAppId = 'cs_micro_frame';
/**
 * 统一api错误埋点
 */
export const trackApiError = (optios) => {
  try {
    if (optios?.api) {
      optios.api = `${omegaEvnetAppId}/${optios.api?.split?.('?')?.[0]}`
    }
    window?.SuperOmega?.trackEvent && window.SuperOmega.trackEvent('tech_cs_work_api_error', 'tech_cs_work_api_error', optios)
  } catch (err) {
    console.log(err)
  }
}
/**
 * 统一业务监控埋点
 */
export const traceCommonEvent = (eventId, optios = {}) => {
  try {
    eventId = `${omegaEvnetAppId}_${eventId}`
    window?.SuperOmega?.trackEvent && window.SuperOmega.trackEvent('tech_cs_work_event', 'tech_cs_work_event',  {event: eventId, username: getCookie('user_name'), version: '--', ...optios})
  } catch (err) {
    console.log &&console.log(err)
  }
}

export const initOmega = (param) => {
  SuperOmega.initOmega(Object.assign({},{
    appKey: "omega4aefb7c55a",
    pt: "cs-micro-front-end",
    // country_code: "JP",
  }, param))
  getCommonParam()

  SuperOmega.setOmgAttrs({
    env: Env.env,
    canonical_country_code: cookieMap.canonical_country_code,
    lang: cookieMap.lang,
    user_name: cookieMap.user_name,
    userid: cookieMap.userid,
    user_id: cookieMap.userid,
    organization_id: cookieMap.organization_id,
    utc_offset: cookieMap.utc_offset,
    workbench_version : SET_WORKBENCH_VERSION(),
    browser_name: SET_EXPLORER_NAME(),
    ticket_state: window.sessionStorage.getItem('ticket_state'),
    workbench_type: set_workbench_type() , // window.sessionStorage.getItem('workbench_type')
    ticket_id: window.sessionStorage.getItem('ticket_id'),
  })
  window.SuperOmega = SuperOmega
  /** app初始化上报， 5s延时上报，假设：停留5s证明想要访问页面 */
  setTimeout(() => {
    traceCommonEvent('loaded')
  }, 5 * 1000);
  /** 上报PC分辨率 */
  window?.SuperOmega?.trackEvent && window.SuperOmega.trackEvent('ibt_cs_work_pc_resolution_sw', 'ibt_cs_work_pc_resolution_sw',  {
    resolution: `${document?.body?.clientWidth} * ${document?.body?.clientHeight}`
  })
}
export const trackEvent = SuperOmega.trackEvent
export const trackClickEvent = SuperOmega.trackClickEvent
export const setOmgAttrs = SuperOmega.setOmgAttrs
export const trackDiyError = SuperOmega.trackDiyError

export const getOmegaInstance = (appKey) => {
  let Omega = OmegaTracker.getTracker({
    appKey,
  });

  return {
    Omega: Omega,
    trackEvent: () => {

    },
    trackClickEvent: (eventId, attrs) => {
      Omega.trackEvent(eventId, '');
    },
    trackDiyError: () => {

    }
  }
}
